var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f63953c151b0dab020e48bdbe930df2fcd438cf7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["straumur-web@kvika"]={id:"f63953c151b0dab020e48bdbe930df2fcd438cf7"};
      